export const footer = [
  {
    name: "Helpline number",
    num: "18002652452",
  },
  {
    name: "Helpline number",
    num: "18002652452",
  },
  {
    name: "Helpline number",
    num: "18002652452",
  },
];
